import { ReactElement } from "react";
import { useNavigate } from "react-router-dom";

import Preloader from "../components/Preloader/Preloader.tsx";
import { AppRoute } from "../constants.ts";
import { useCurrentUserContext } from "./CurrentUserProvider.tsx";

interface Props {
  children: ReactElement;
}

export const NoAuthGuard = ({ children }: Props) => {
  const { user, fetching } = useCurrentUserContext();

  const navigate = useNavigate();

  if (user) {
    navigate(AppRoute.Home);
  }

  if (fetching || user) {
    return <Preloader loading={true} />;
  }

  return children;
};
